import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { ContactPreview } from "components/PreviewPanel/contact/ContactPreviewPanel";
import { useContact } from "utilities/hookutils";

type Props = RemovableProps<server.dto.ContactSmallV2>;

export const RemovableContactLabel = (props: Props) => {
  const contact = useContact(props.value);

  return <RemovableLabel {...props}>
    <div>
      <ContactPreview
        contactId={props.value.contactId}
        trigger={<a>{contact.name.fullName}</a>}
      />
      {props.value.position && <div className="text-sublabel">
        {props.value.position}
      </div>}
    </div>
  </RemovableLabel>;
};